// NOTE: These need to match what FDM checks for in mutations/learner_files.py
export type INTERVIEW_TYPE_TYPE = "parent" | "child" | "teacher" | "other";

export const interviewTypeMap: { [code in INTERVIEW_TYPE_TYPE]: string } = {
  child: "Child",
  parent: "Parent",
  teacher: "Teacher",
  other: "Other",
};
